import { View } from 'react-native';

import type { ChargingRecord } from '@/api';
import { GREY_40 } from '@/style/colors';
import { Card, Text } from '@/ui';

export default function SuperchargingCard({
  chargingRecord,
}: {
  chargingRecord: ChargingRecord;
}) {
  return (
    <Card style={{ gap: 8, padding: 16 }}>
      <View>
        <Text tx="tolls.location" type="caption1" style={{ color: GREY_40 }} />

        <Text type="bodyRegular">{chargingRecord.name}</Text>
      </View>

      <View>
        <Text tx="tolls.time" type="caption1" style={{ color: GREY_40 }} />

        <Text type="bodyRegular">{chargingRecord.date}</Text>
      </View>

      <View>
        <Text tx="tolls.cost" type="caption1" style={{ color: GREY_40 }} />

        <Text type="bodyRegular">{`$${chargingRecord.amount}`}</Text>
      </View>
    </Card>
  );
}
